import React, { useEffect, useState } from 'react';
import { Box, FormControl, Typography } from '@mui/material';
import {
  FormLabelText,
  RemarksTextAreaWrapper,
  RemarksTitleText,
  SectionContainerWrapper,
  StyledButton,
  TextAreaField
} from '../../styled';
import { useFeeStructureContext } from '../../context/FeeStructureContext';
import pallet from '../../../../layouts/pallet';

const RolloverRemark = () => {
  const {
    remarks,
    paymentSchemeRemarksUpdate,
    remarksUpdating,
    admissionType
  } = useFeeStructureContext();

  const [charCount, setCharCount] = useState<number>(0);
  const [remark, setRemarks] = useState('');

  useEffect(() => {
    setRemarks(remarks || '');
    setCharCount(remarks?.length || 0);
  }, [remarks]);

  const handleRemarksUpdate = () => {
    paymentSchemeRemarksUpdate({ newRemark: remark });
  };

  return (
    <SectionContainerWrapper>
      <RemarksTitleText>
        Remarks for{' '}
        {admissionType === 'rollover' ? 'Rollover' : 'New Admission'} Fees
      </RemarksTitleText>
      <RemarksTextAreaWrapper>
        <Box sx={{ flex: 1 }}>
          <FormControl fullWidth>
            <FormLabelText>Remarks</FormLabelText>
            <TextAreaField
              value={remark}
              minRows={1}
              maxLength={800}
              aria-label='maximum height'
              placeholder='Enter value'
              onChange={(e) => {
                const value = e.target.value;
                setCharCount(value.length);
                setRemarks(value);
              }}
            />
          </FormControl>
          <Typography variant='caption' sx={{ color: pallet.lightBlueText }}>
            {charCount}/800
          </Typography>
        </Box>
        <StyledButton
          sx={{ marginTop: '8px' }}
          onClick={() => handleRemarksUpdate()}
          disabled={!!remarksUpdating}
        >
          Save
        </StyledButton>
      </RemarksTextAreaWrapper>
    </SectionContainerWrapper>
  );
};

export default RolloverRemark;
